// extracted by mini-css-extract-plugin
module.exports = {"input":"SpecialCategoryForm_input__2hMzp"};